import { css } from 'styled-components';
import { margin } from './margin';
import { padding } from './padding';
export const getFormattedSpaceValue = (value) => typeof value === 'number' ? `${value}px` : value;
export const space = css `
  ${margin}
  ${padding}
`;
